/* global gtag */
import createAdapter from './createAdapter'
export const remarketing = createAdapter(() => !!window.gtag, {
  track(value, currency) {
    const eventIds = [
      'AW-455488219/43HQCIOft-4BENvlmNkB',
      'AW-455488219/rMu3CLHH7O4BENvlmNkB',
    ]

    eventIds.forEach((send_to) => {
      gtag('event', 'conversion', {
        send_to,
        currency,
        value: parseInt(value, 10),
      })
    })

    const remarketingEventIds = [
      'AW-940661836/WUj-CK62nekBEMy4xcAD',
      'AW-940661836/SlMCCOu9nekBEMy4xcAD',
    ]

    remarketingEventIds.forEach((send_to) => {
      gtag('event', 'conversion', {
        send_to,
        currency,
        value: parseInt(value, 10),
        aw_remarketing_only: true,
      })
    })
  },
})
